window.axios = require("axios");

class CartQf {
  constructor() {
    this.cart = window.QF.cart;

    this.endpoints = {
      add: {
        url: 'cart/add.js',
        method: 'post'
      },
      get: {
        url: 'cart.js',
        method: 'get'
      },
      update: {
        url: 'cart/update.js',
        method: 'post'
      },
      clear: {
        url: 'cart/clear.js',
        method: 'post'
      }
    }

    this.selectors = {
      cartDrawerContainer: '#cart-drawer-container'
    }
  }

  dispatchEvent(event_name, includeCart) {
    let contents = null
    if (includeCart) {
      contents = {
        detail: {
          cart: this.cart,
        },
      }
    }
    window.dispatchEvent(new CustomEvent(event_name, contents))
  }

  add(data) {
    return new Promise((resolve, reject) => {
      this.request('add', data).then(({ data }) => {
        this.klaviyoAddToCart(data)
        this.mergeWithCurrentCart(data)
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("item_added", true)
        resolve(this.cart)

        
        
        const vw = window.innerWidth;


        window.cart.reRenderSideCart();
        if ( vw > 991.98 ) {
          
          this.openDesktopSideCart();
          
        }

        /*
        if (screen.width < 991.98) {
          const mobileSideCartOpened = sessionStorage.getItem('mobileSideCartOpened')
          if (mobileSideCartOpened !== 'true') {
            this.openSideCart()
            sessionStorage.setItem('mobileSideCartOpened', 'true')
          } else {
            window.cart.reRenderSideCart();
          }
        } else {
          this.openDesktopSideCart()
        }
        */
      }).catch((error) => {
        reject(error)
      })
    });
  }

  get() {
    return new Promise((resolve, reject) => {
      this.request('get').then((response) => {
        this.cart = response.data;
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  update(data) {
    return new Promise((resolve, reject) => {
      this.request('update', data).then(({ data }) => {
        this.cart = data;
        this.dispatchEvent("cart_changed", true)
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  remove(variant_id) {
    return new Promise((resolve, reject) => {
      let updates = {
        updates: {
          [variant_id]: 0,
        }
      }
      this.request('update', updates).then(({ data }) => {
        this.cart = data;
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("item_removed", true)
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    })
  }

  clear() {
    return new Promise((resolve, reject) => {
      this.request('clear').then(({ data }) => {
        this.cart = data
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("cart_cleared", true)
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  async request(key, data) {
    return new Promise((resolve, reject) => {
      const url = window.Shopify.routes.root + this.endpoints[key].url;
      const method = this.endpoints[key].method;
      axios({
        method,
        url,
        data,
        headers: {
          'Content-Type': 'application/json'
        },
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        if (error.response) {
          // Request made and server responded
          reject(error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          reject(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error.message)
        }
      })
    })
  }

  mergeWithCurrentCart(data) {
    if (data.items) {
      data.items.forEach((item) => {
        let index = this.cart.items.findIndex(e => e.id === item.id);
        if (index > -1) {
          this.cart.items[index] = item;
        } else {
          this.cart.items.push(item)
        }
      });
    }
  }

  openSideCart() {
    this.reRenderSideCart(() => {
      let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
      let customer_el = document.querySelector("#MainContent");
      let loggedin = this.guestLogin();
      
      if (loggedin == true) {
        window.modalController.presentModal("modal-login");
      } else if (loggedin == true && customer_el.classList.contains("is-customer")) {
        if (sideCartContainer) {
          sideCartContainer.classList.add("open");
          document.body.classList.add("fixed");
          sideCartContainer.style.height = window.innerHeight + "px";
          window.addEventListener("resize", () => {
            sideCartContainer.style.height = window.innerHeight + "px";
          })
          this.dispatchEvent("side_cart_closed", false)
        }
      } else {
        if (sideCartContainer) {
          sideCartContainer.classList.add("open");
          document.body.classList.add("fixed");
          sideCartContainer.style.height = window.innerHeight + "px";
          window.addEventListener("resize", () => {
            sideCartContainer.style.height = window.innerHeight + "px";
          })
          this.dispatchEvent("side_cart_closed", false)
        }
      }

    });
  }

  closeSideCart() {
    let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
    if (sideCartContainer) {
      sideCartContainer.classList.remove("open");
      document.body.classList.remove("fixed");
      this.dispatchEvent("side_cart_closed", false)
    }
  }

  openDesktopSideCart() {
    this.reRenderDesktopSideCart(() => {
      const main_container = document.querySelector('.main-side-cart-container');
      if (!main_container.classList.contains('side-cart-active')) {
        main_container.classList.add('side-cart-active')
        window.sessionStorage.setItem("desktopSideCart", "active");
      }
    });
  }

  closeDesktopSideCart() {
    const main_container = document.querySelector('.main-side-cart-container');
    if (main_container.classList.contains('side-cart-active')) {
      main_container.classList.remove('side-cart-active')
      window.sessionStorage.setItem("desktopSideCart", "");
    }
  }

  // Calls the seciton rendering API to render the v2-side-cart section (with refference to the cart page) and inserts the section html into the side cart
  async reRenderSideCart(successCallback = null) {
    await axios
      .get(" /cart?sections=v2-side-cart", {})
      .then((response) => {
        // Success
        let html = response.data["v2-side-cart"];
        let side_cart_inner = document.querySelector(
          "#cart-drawer-container .inner"
        );

        if (side_cart_inner && html) {
          side_cart_inner.innerHTML = html;

          let cart_total = parseInt(side_cart_inner.querySelector('.sub-total').getAttribute('data-sub-total'));
          let min_order = parseInt(document.querySelector('.desktop-side-cart').getAttribute('data-min-order'));

          this.minimumOrder(cart_total, min_order);

          let item_count = parseInt(side_cart_inner.querySelector('.cart').getAttribute('data-items-count'));
          const item_count_el = document.querySelector('#cart-drawer-container .items-count');
          let cart_count_els = document.querySelectorAll('.cart-counter');

          if (item_count == 0) {
            item_count_el.innerHTML = '';
          } else if (item_count == 1) {
            item_count_el.innerHTML = '(1 item)';
            cart_count_els.forEach(cart_count_el => {
              cart_count_el.style.visibility = "visible";
              cart_count_el.innerHTML = `${item_count}`;
            })
          } else {
            item_count_el.innerHTML = `(${item_count} items)`;
            cart_count_els.forEach(cart_count_el => {
              cart_count_el.style.visibility = "visible";
              cart_count_el.innerHTML = `${item_count}`;
            })
          }

          this.cartRenderedEvent(response, html)

          let items = side_cart_inner.querySelectorAll(".item");

          items.forEach(item => {
            // let quantity = parseInt(item.querySelector('.quantity span').innerHTML);
            // let max_order = parseInt(item.querySelector('.quantity span').dataset.maxPerOrder);
            let variant_id = item.getAttribute('data-variant-id');
            let plus = item.querySelector('.plus');


            // if (quantity >= max_order) {
            //   plus.setAttribute("data-pending", true)
            // }

            // if (quantity > max_order) {
            //   let reached_limit = document.createElement("div");
            //   reached_limit.classList.add('reached-limit');
            //   reached_limit.innerHTML = "Maximum order quantity reached";
            //   item.append(reached_limit)
            //   this.setToMax(variant_id,max_order)
            // }

            let stock = parseInt(item.getAttribute('data-stock-check'));

            if (stock < 1) {
              this.quantityCheck(variant_id, stock);
            }
          })

          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        window.log("Error:", error);
      })
  }

  async reRenderDesktopSideCart(successCallback = null) {
    await axios
      .get(" /cart?sections=v2-side-cart", {})
      .then((response) => {
        // Success
        let html = response.data["v2-side-cart"];
        let side_cart_inner = document.querySelector(
          ".desktop-side-cart .inner"
        );

        if (side_cart_inner && html) {
          side_cart_inner.innerHTML = html;

          let cart_total = parseInt(side_cart_inner.querySelector('.sub-total').getAttribute('data-sub-total'));
          let min_order = parseInt(document.querySelector('.desktop-side-cart').getAttribute('data-min-order'));
          
          this.minimumOrder(cart_total, min_order);

          let item_count = parseInt(side_cart_inner.querySelector('.cart').getAttribute('data-items-count'));
          const item_count_el = document.querySelector('.desktop-side-cart .items-count');
          let cart_count_els = document.querySelectorAll('.cart-counter');

          if (item_count == 0) {
            item_count_el.innerHTML = '';
          } else if (item_count == 1) {
            item_count_el.innerHTML = '(1 item)';
            cart_count_els.forEach(cart_count_el => {
              cart_count_el.style.visibility = "visible";
              cart_count_el.innerHTML = `${item_count}`;
            })
          } else {
            item_count_el.innerHTML = `(${item_count} items)`;
            cart_count_els.forEach(cart_count_el => {
              cart_count_el.style.visibility = "visible";
              cart_count_el.innerHTML = `${item_count}`;
            })
          }

          this.cartRenderedEvent(response, html);

          let items = side_cart_inner.querySelectorAll(".item");

          items.forEach(item => {
            // let quantity = parseInt(item.querySelector('.quantity span').innerHTML);
            // let max_order = parseInt(item.querySelector('.quantity span').dataset.maxPerOrder);
            let variant_id = item.getAttribute('data-variant-id');
            let plus = item.querySelector('.plus');


            // if (quantity >= max_order) {
            //   plus.setAttribute("data-pending", true)
            // }

            // if (quantity > max_order) {
            //   let reached_limit = document.createElement("div");
            //   reached_limit.classList.add('reached-limit');
            //   reached_limit.innerHTML = "Maximum order quantity reached";
            //   item.append(reached_limit)
            //   this.setToMax(variant_id,max_order)
            // }

            let stock = parseInt(item.getAttribute('data-stock-check'));

            if (stock < 1) {
              this.quantityCheck(variant_id, stock);
            }
          })

          // Progress Bar
          const sideCart = document.querySelector('.desktop-side-cart');
          const progressWrapper = sideCart.querySelector('.order-progress-wrapper');
          console.log('progressWrapper: ', progressWrapper)
          if ( progressWrapper ) {
            const updatedCart = side_cart_inner.querySelector('.cart');
            const cart_total = parseFloat( updatedCart.dataset.cartTotal );
            const min_order_amount = parseFloat( progressWrapper.dataset.minOrder );
            const free_delivery_amount = parseFloat( progressWrapper.dataset.freeDelivery );
            const progressMessageEl = progressWrapper.querySelector('.progress-message');
            
            
            const updateProgressMessage = () => {
              let msg; 
              let distance;
              let distanceFormatted;
              if ( cart_total < min_order_amount ) {
                distance = min_order_amount - cart_total;
                distanceFormatted = window.Shopify.formatMoney( distance ).replace('$', '£');
                msg = `You are <span>${ distanceFormatted }</span> away from <span>Minimum Order</span>`;
                
              } else if ( cart_total < free_delivery_amount ) {
                distance = free_delivery_amount - cart_total;
                distanceFormatted = window.Shopify.formatMoney( distance ).replace('$', '£');
                msg = `You are <span>${ distanceFormatted }</span> away from <span>FREE Delivery</span>`;
                
              } else {
                msg = `You have qualified for <span>FREE Delivery</span>`
              }
              console.log('msg: ', msg);
              progressMessageEl.innerHTML = msg;
            }
            
            console.log('cart_total:  ', cart_total, ' | min_order: ', min_order_amount, ' | free_delivery: ', free_delivery_amount  );
            
            const min_order_percent = ( min_order_amount / free_delivery_amount ) * 100 + '%';
            const cart_total_percent = Math.min( (( cart_total / free_delivery_amount ) * 100 ), 100 ) + '%';
            console.log('cart_total_percent: ', cart_total_percent)
              
            // Update Progress Bar
            progressWrapper.style.setProperty('--cart-progress', cart_total_percent);
            
            // Progress Colour
            if ( cart_total < min_order_amount ) progressWrapper.style.setProperty('--cart-progress-color', '#e0004d');
            else progressWrapper.style.setProperty('--cart-progress-color', '#84bd00');
            
            // Update Message
            updateProgressMessage();
          }

          if (successCallback) {
            successCallback();
          }
          
        }
      })
      .catch((error) => {
        window.log("Error:", error);
      })
  }

  async reRenderCart() {
    await axios
      .get(" /cart?sections=ve-cart", {})
      .then(function (response) {
        let html = response.data["ve-cart"];
        let cart_inner = document.querySelector("#cart-container");

        if (cart_inner && html) {
          cart_inner.innerHTML = html;

          let items = document.querySelectorAll(".cart .item .quantity span");

          // const checkout = document.querySelector('.cart-details .checkout-btn');
          // const min_order_el = document.querySelector('.cart-details .minimum-order span');
          // const min_order_svg = document.querySelector('.cart-details .minimum-order svg');
          // let cart_total = document.querySelector('.cart-details .sub-total-wrapper .sub-total').getAttribute('data-sub-total');

          // let min_order_value = min_order_el.getAttribute('data-min-order');

          // if(cart_total >= min_order_value) {
          //   min_order_el.innerHTML = "reached";
          //   checkout.classList.remove("disabled");
          //   min_order_svg.style.display = "block";
          // } else {
          //   min_order_el.innerHTML = (min_order_value / 100).toFixed(2);
          //   checkout.classList.add("disabled");
          //   min_order_svg.style.display = "none";
          // }

          // items.forEach(item => {
          //   let quantity = parseInt(item.innerHTML);
          //   let max_order = item.dataset.maxPerOrder;
          //   let plus = item.parentNode.nextElementSibling;

          //   if (quantity == max_order) {
          //     plus.setAttribute("data-pending", true)
          //   }
          // })

          this.cartRenderedEvent(response, html)
        }
      })
      .catch(function (error) {
        window.log("Error:", error);
      })
  }

  cartRenderedEvent(response, html) {
    window.dispatchEvent(new CustomEvent("cart_rendered", {
      detail: {
        response: response,
        html: html,
      },
    }));
  }

  quantityCheck(variant_id, stock) {
    window.modalController.presentModal("modal-item-removed", 0, variant_id);
    this.remove(variant_id);
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // setToMax(variant_id,max_order) {
  //   this.update({ updates: { [variant_id]: max_order } });
  // }

  guestLogin() {
    let login = this.getCookie("customer")
    let guest;

    switch (login) {
      case '':
        guest = true;
        return guest;
        break;
      case 'guest':
        guest = false;
        return guest;
        break;
      case 'loggedin':
        guest = false;
        return guest;
    }
  }

  minimumOrder(cart_total, min_order) {
    const checkout_buttons = document.querySelectorAll('.buttons');
    if (cart_total < min_order) {
      checkout_buttons.forEach(checkout_button => {
        checkout_button.classList.add("disabled");
      })
    } else {
      checkout_buttons.forEach(checkout_button => {
        checkout_button.classList.remove("disabled");
      })
    }
  }

  klaviyoAddToCart(data) {
    item = data.items[0];
    var _learnq = window._learnq || [];
    addedToCart = () => {
      window.fetch(`${window.location.origin}/cart.js`)
        .then(res => res.clone().json().then(data => {
          var cart = {
            total_price: data.total_price / 100,
            $value: data.total_price / 100,
            total_discount: data.total_discount,
            original_total_price: data.original_total_price / 100,
            items: data.items
          }
          if (item !== 'undefined') {
            cart = Object.assign(cart, item)
          }
          if (klAjax) {
            _learnq.push(['track', 'Added to Cart', cart]);
            klAjax = false;
          }
        }))
        .catch(error => console.error('Error fetching cart:', error));
    };

    ((ns, fetch) => {
      ns.fetch = (...args) => {
        const response = fetch.apply(window, args);
        response.then(res => {
          if (`${window.location.origin}/cart/add.js`.includes(res.url)) {
            addedToCart();
          }
        });
        return response;
      };
    })(window, window.fetch);
    var klAjax = true;
    if (klAjax) {
      _learnq.push(['track', 'Added to Cart', item]);
      klAjax = false;
    }
  }
}

// export default new CartQf();
window.CartQf = CartQf;